import * as React from 'react';
import { ProductCard, ProductCardProps } from '@/components/features/cms/blocks/ProductCard/ProductCard';
import { ProductCard as DSProductCard } from '@/components/shared/ProductCard/ProductCard';

export const ProductCardWithOverrides: React.FC<ProductCardProps> = (props) => {
	return <ProductCard {...props} DSProductCard={DSProductCard} />;
};
